import React from 'react';

const ButtonFactoryPreviewPPLogoHeader = ({}) => {
  return (
    <div className="pp-logo-holder" aria-hidden="true">
      <img
        src="https://www.paypalobjects.com/paypal-ui/logos/svg/paypal-color.svg"
        data-testid="button-factory-preview-pp-logo-header"
      />
    </div>
  );
};

export default ButtonFactoryPreviewPPLogoHeader;
